module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2022/polkolonie/big/5-55577d0831476832ccdab2d61801bb76.webp";